var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 46,
    viewBox: "0 0 50 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_263_193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6006 44.5571H13.2148C14.7664 44.3657 16.1949 43.6093 17.2311 42.4305C18.2672 41.2516 18.8395 39.7316 18.84 38.1571V31.8281H28.9754V38.1571C28.9759 39.7316 29.5482 41.2516 30.5844 42.4305C31.6206 43.6093 33.049 44.3657 34.6006 44.5571Z",
    fill: "#E0DEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5836 33.8709H2.68054C1.96961 33.8709 1.28781 33.5864 0.785112 33.0801C0.282413 32.5737 0 31.887 0 31.1709V2.70391C0 1.98782 0.282413 1.30106 0.785112 0.794716C1.28781 0.288368 1.96961 0.00390625 2.68054 0.00390625H43.5836C44.2945 0.00390625 44.9763 0.288368 45.479 0.794716C45.9817 1.30106 46.2641 1.98782 46.2641 2.70391V31.1689C46.2644 31.5236 46.1952 31.875 46.0606 32.2028C45.9261 32.5306 45.7287 32.8285 45.4797 33.0794C45.2308 33.3303 44.9352 33.5294 44.6098 33.6652C44.2845 33.801 43.9358 33.8709 43.5836 33.8709Z",
    fill: "#E8E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8999 45.9996H5.32248C5.14475 45.9996 4.97429 45.9285 4.84862 45.8019C4.72294 45.6753 4.65234 45.5036 4.65234 45.3246V45.2336C4.65234 45.0546 4.72294 44.8829 4.84862 44.7563C4.97429 44.6297 5.14475 44.5586 5.32248 44.5586H41.8999C42.0777 44.5586 42.2481 44.6297 42.3738 44.7563C42.4995 44.8829 42.5701 45.0546 42.5701 45.2336V45.3246C42.5701 45.5036 42.4995 45.6753 42.3738 45.8019C42.2481 45.9285 42.0777 45.9996 41.8999 45.9996Z",
    fill: "#E8E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00440272 2.81232V28.4053H46.3678V2.81232C46.3678 2.72832 46.2606 2.60633 46.2556 2.48633H0.00638816C0.00241699 2.60533 0.00440272 2.72732 0.00440272 2.81232Z",
    fill: "#4384EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00440272 2.81232V28.3713L46.3172 2.80633C46.3172 2.72233 46.2616 2.60633 46.2576 2.48633H0.00638816C0.00241699 2.60533 0.00440272 2.72732 0.00440272 2.81232Z",
    fill: "#2666CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9753 33.8711H18.8398V35.9531H28.9753V33.8711Z",
    fill: "#D3CDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3702 28.4047V19.8047H31.4604C31.283 19.8064 31.1076 19.8434 30.9443 19.9135C30.7811 19.9836 30.6331 20.0855 30.5091 20.2134C30.385 20.3412 30.2872 20.4925 30.2213 20.6585C30.1555 20.8245 30.1228 21.0019 30.1251 21.1807V28.4047H46.3702Z",
    fill: "#2666CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.125 28.4043V33.8983H43.4026C44.1755 33.8958 44.9173 33.5907 45.471 33.0475C46.0248 32.5043 46.3471 31.7655 46.3701 30.9873V28.4043H30.125Z",
    fill: "#D3CDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1404 43.7009C31.3282 43.2542 30.6364 42.6147 30.125 41.8379V44.5289H32.1404V43.7009Z",
    fill: "#D3CDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7679 44.5566H30.1211V46.0006H32.7679V44.5566Z",
    fill: "#E0DEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7313 46.0004H32.6829C32.3464 46.0004 32.0236 45.8658 31.7857 45.6261C31.5477 45.3864 31.4141 45.0614 31.4141 44.7224V21.0944C31.4141 20.7555 31.5477 20.4304 31.7857 20.1907C32.0236 19.951 32.3464 19.8164 32.6829 19.8164H48.7313C49.0678 19.8164 49.3906 19.951 49.6285 20.1907C49.8664 20.4304 50.0001 20.7555 50.0001 21.0944V44.7234C49.9999 45.0622 49.8661 45.387 49.6282 45.6264C49.3903 45.8659 49.0677 46.0004 48.7313 46.0004Z",
    fill: "#D3CDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 22.0703H31.4141V42.3893H50.0001V22.0703Z",
    fill: "#4384EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4141 42.3933V22.0703H50.0001L31.4141 42.3933Z",
    fill: "#2666CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5995 44.5592H39.8125C39.7017 44.5592 39.5953 44.5148 39.517 44.4359C39.4386 44.3569 39.3945 44.2498 39.3945 44.1382V44.0811C39.3945 43.9695 39.4386 43.8624 39.517 43.7835C39.5953 43.7045 39.7017 43.6602 39.8125 43.6602H41.5995C41.7104 43.6602 41.8167 43.7045 41.8951 43.7835C41.9735 43.8624 42.0175 43.9695 42.0175 44.0811V44.1382C42.0175 44.2498 41.9735 44.3569 41.8951 44.4359C41.8167 44.5148 41.7104 44.5592 41.5995 44.5592Z",
    fill: "#E8E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_263_193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPlatform);
export default __webpack_public_path__ + "static/media/default_platform.2ef9d4acf05be614d8bdc80122db3641.svg";
export { ForwardRef as ReactComponent };